import PropTypes from "prop-types"
import moment from "moment"
import { OfflineBolt } from "@mui/icons-material"
import { DATE } from "helpers/shapes"
import { DATABASE_DATE_FORMAT } from "helpers/formatters/dates"
import Tooltip from "components/material/tooltip"

export default function Bolt({ startDate, endDate, isActive }) {
  // If the selected (adjusted) range is greater or equal to a year, we dont display the bolt
  if (Math.abs(moment(startDate, DATABASE_DATE_FORMAT).diff(moment(endDate, DATABASE_DATE_FORMAT), "years")) >= 1) {
    return null
  }

  return <Tooltip title={`Less than one year of cumulative returns is used in this annualized ${isActive ? "Information ratio" : "Sharpe"}`}><OfflineBolt /></Tooltip>
}

Bolt.propTypes = {
  startDate: DATE.isRequired,
  endDate: DATE.isRequired,
  isActive: PropTypes.bool.isRequired,
}
